export const getCookie = (string: string) => {
  const rawCookie =
    document.cookie.match('(^|;)\\s*' + string + '\\s*=\\s*([^;]+)')?.pop() ||
    undefined
  return rawCookie && JSON.parse(decodeURIComponent(rawCookie))
}
